import _ from 'lodash'
import {log} from 'common/log';
import {KostStateType} from 'module/Kost/reducer/KostReducer'
import {AppName, getAppName} from 'util/AppName'

const _VERSION = 9; // on upgrade increment by 1

export function upgradeReduxState(state: any) {
	if (!state) return {_VERSION}
	const version = state._VERSION || 0
	log.debug('current redux state version', version)
	if (version === _VERSION) return state;
	log.debug('upgrading', version, 'to', _VERSION)

	//always
	state.BSCollection = undefined

	if (version < 1) {
		const pth = ['Pagination', 'namespace']
		if (!_.get(state, pth)) {
			state = _.set(state, pth, {})
		}
	}
	if (version < 3) {
		state = _.omit(state, 'UserConfig.SessionInfo')
	}
	if (version < 6) {
		const {KostPreInit, ...rest} = state
		if (KostPreInit) {
			state = {...rest, MultiKostInit: KostPreInit}
		}
	}
	if (version < 7) {
		if (state.DataFilter && !state.DataFilter?.quickAccess) _.set(state, ['DataFilter', 'quickAccess'], [])
	}
	if (version < 8) {
		if (state.Clipboard) state.Clipboard = {}
	}
	if (version < 9) {
		if (getAppName() === AppName.sheet && (state as KostStateType).Kost.visibleIds?.length) {
			state.Kost.visibleIds = []
		}
	}
	if (version < 10) {
		// ...add new upgrades here after incrementing current version
	}

	state._VERSION = _VERSION
	return state;
}